var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAssets = function SvgAssets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.913 2.78c0-1.384.995-2.622 2.357-2.622h.92c.887 0 1.665.548 2.062 1.366q.091.188.218.337l.084.1c.264.313.612.473.958.473h2.663c1.273 0 2.225 1.083 2.344 2.355.41.102.768.311 1.001.654.367.54.302 1.226-.05 1.894l-.01.018-2.118 3.33a2.36 2.36 0 0 1-1.989 1.091H3.27a2.22 2.22 0 0 1-1.54-.636c-.508-.487-.817-1.203-.817-1.986zm10.592 1.93c-.137-.772-.726-1.28-1.33-1.28H7.511c-.664 0-1.282-.309-1.719-.826l-.084-.1a2.6 2.6 0 0 1-.353-.545c-.253-.522-.71-.805-1.165-.805h-.92c-.691 0-1.361.663-1.361 1.626v6.374q0 .201.039.386L3.49 5.89c.18-.468.548-.765.924-.938a2.8 2.8 0 0 1 1.151-.242zm-8.903 5.86c.201.136.43.21.668.21h6.083a1.36 1.36 0 0 0 1.148-.63l2.097-3.294c.246-.477.18-.734.099-.853-.095-.138-.345-.297-.849-.297H5.565a1.8 1.8 0 0 0-.734.15c-.217.1-.353.235-.413.395l-.004.01-1.779 4.211a1 1 0 0 0-.033.098",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.896 7.295c0-.275.223-.498.498-.498h5.312a.498.498 0 0 1 0 .996H5.394a.5.5 0 0 1-.498-.498",
    clipRule: "evenodd"
  })));
};
export default SvgAssets;